import AddressFormFields from '@/components/AddressFormFields';
import { SVTextInput, SVCheckbox } from '@/components/core';
import { AddWireRecipientForm } from '@/types/wireRecipients';
import { Card, Typography, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export default function WireRecipientFormRecipientInfo() {
  const formMethods = useFormContext<AddWireRecipientForm>();
  const internationalAddress = formMethods.watch(
    'recipientInfo.internationalAddress',
  );

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Wire Recipient Info
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVTextInput
            label="Recipient Nickname"
            name="recipientInfo.nickName"
            rules={{ required: true, maxLength: 30 }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVTextInput
            label="Recipient Name"
            name="recipientInfo.name"
            rules={{ required: true }}
          />
        </Grid>
      </Grid>
      <Typography variant="h6">Recipient Current Address</Typography>
      <SVCheckbox
        label="International Current Address?"
        name="recipientInfo.internationalAddress"
      />
      <AddressFormFields
        line1Name="recipientInfo.line1"
        line2Name="recipientInfo.line2"
        cityName="recipientInfo.city"
        stateName="recipientInfo.state"
        postalCodeName="recipientInfo.zip"
        isInternational={internationalAddress}
        countryName="recipientInfo.country"
      />
    </Card>
  );
}
